export default __webpack_public_path__ + "static/media/928.e434b55a.gif";